import dayjs from 'dayjs';

/** @returns {string|null} YYYY-MM */
export const labelToMonthKey = label => {
  const s = String(label || '').trim();
  let m = s.match(/(\d{4})-(\d{1,2})\b/);
  if (m) return `${m[1]}-${m[2].padStart(2, '0')}`;
  m = s.match(/\b(\d{1,2})[/-](\d{4})\b/);
  if (m) return `${m[2]}-${m[1].padStart(2, '0')}`;

  const yMatch = s.match(/\b(20\d{2})\b/);
  const yy = yMatch ? yMatch[1] : null;
  if (!yy) return null;

  const tests = [
    ['01', /\bjanuary\b|\bjan\.\b|\bjan\b/i],
    ['02', /\bfebruary\b|\bfeb\.\b|\bfeb\b/i],
    ['03', /\bmarch\b|\bmar\.\b|\bmar\b/i],
    ['04', /\bapril\b|\bapr\.\b|\bapr\b/i],
    ['05', /\bmay\b/i],
    ['06', /\bjune\b|\bjun\.\b|\bjun\b/i],
    ['07', /\bjuly\b|\bjul\.\b|\bjul\b/i],
    ['08', /\baugust\b|\baug\.\b|\baug\b/i],
    ['09', /\bseptember\b|\bsept\.\b|\bsep\.\b|\bsept\b|\bsep\b/i],
    ['10', /\boctober\b|\boct\.\b|\boct\b/i],
    ['11', /\bnovember\b|\bnov\.\b|\bnov\b/i],
    ['12', /\bdecember\b|\bdec\.\b|\bdec\b/i],
  ];
  for (const [mm, re] of tests) {
    if (re.test(s)) return `${yy}-${mm}`;
  }
  return null;
};

/** @returns {string[]} YYYY-MM inclusive from report range */
export const monthKeysInReportRange = (startDateStr, endDateStr) => {
  if (!startDateStr || !endDateStr) return [];
  const start = dayjs(startDateStr).startOf('month');
  const end = dayjs(endDateStr).startOf('month');
  if (!start.isValid() || !end.isValid() || end.isBefore(start)) return [];

  const keys = [];
  let cur = start;
  while (cur.isBefore(end) || cur.isSame(end, 'month')) {
    keys.push(cur.format('YYYY-MM'));
    cur = cur.add(1, 'month');
  }
  return keys;
};
